import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModuleNav, ModuleNavItem } from '../../contexts/ModuleNavContext';
import { useMenu } from '../../auth/useMenu';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';

const ALL_SCOUTING_NAV_ITEMS: ModuleNavItem[] = [
  { to: '/scouting', labelKey: 'nav.overview', end: true, group: 'nav.groups.overview' },
  { to: '/scouting/field-v2', labelKey: 'nav.fieldModeV2', subject: 'scouting:fieldModeV2', group: 'nav.groups.capture' },
  { to: '/scouting/phenology', labelKey: 'nav.phenology', subject: 'scouting:phenology', group: 'nav.groups.capture' },
  { to: '/scouting/manual-v2', labelKey: 'nav.manualCaptureV2', subject: 'scouting:manualCaptureV2', group: 'nav.groups.capture' },
  { to: '/scouting/config', labelKey: 'nav.pestConfig', subject: 'scouting:pestConfig', group: 'nav.groups.capture' },
  { to: '/scouting/review', labelKey: 'nav.reviewV2', subject: 'scouting:reviewV2', group: 'nav.groups.analyze' },
];

export const SCOUTING_NAV_ITEMS = ALL_SCOUTING_NAV_ITEMS;

const ScoutingLayout: React.FC = () => {
  const { t } = useTranslation();
  const { setModule } = useModuleNav();
  const hasFieldModeV2 = useMenu('scouting:fieldModeV2');
  const hasPhenology = useMenu('scouting:phenology');
  const hasManualCaptureV2 = useMenu('scouting:manualCaptureV2');
  const hasPestConfig = useMenu('scouting:pestConfig');
  const hasReviewV2 = useMenu('scouting:reviewV2');

  const filteredItems = useMemo(() => {
    const menuMap: Record<string, boolean> = {
      'scouting:fieldModeV2': hasFieldModeV2,
      'scouting:phenology': hasPhenology,
      'scouting:manualCaptureV2': hasManualCaptureV2,
      'scouting:pestConfig': hasPestConfig,
      'scouting:reviewV2': hasReviewV2,
    };
    return ALL_SCOUTING_NAV_ITEMS.filter(item => !item.subject || menuMap[item.subject]);
  }, [hasFieldModeV2, hasPhenology, hasManualCaptureV2, hasPestConfig, hasReviewV2]);

  useEffect(() => {
    setModule(t('nav.scouting'), filteredItems);
    return () => setModule(null, null);
  }, [setModule, t, filteredItems]);

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('nav.scouting'), to: '/scouting' },
  ]);

  return (
    <div data-testid="scouting-layout">
      <Outlet />
    </div>
  );
};

export default ScoutingLayout;
